import React, { useState } from "react";

import { ModalDispatcherContext, Product } from "./context";
import { Modal } from "./Modal";

const DetailModalProvider: React.FC = ({ children }) => {
  const [productDetails, setProductDetails] = useState<Product>(null);
  return (
    <ModalDispatcherContext.Provider value={setProductDetails}>
      {Boolean(productDetails) && <Modal product={productDetails!} />}
      {children}
    </ModalDispatcherContext.Provider>
  );
};

export { DetailModalProvider };
